import { render, staticRenderFns } from "./UsuarioGeral.vue?vue&type=template&id=1d025fd8"
import script from "./UsuarioGeral.vue?vue&type=script&lang=js"
export * from "./UsuarioGeral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports